import { t } from '../../logical/type-presets.js';
import { createFilter } from './create.js';

const lengthOf = (self: unknown): number => {
  if (Array.isArray(self)) return self.length;
  if (typeof self === 'string') return self.length;
  return self == null ? 0 : 1;
};

export const unknownFilter = [
  createFilter({
    name: 'isNotEmpty',
    self: t.unknown.instance(),
    args: [] as const,
    label: 'Is not empty',
    shortString: () => ': Is not empty',
    impl: self => {
      if (Array.isArray(self)) {
        return self.length > 0;
      }
      if (typeof self === 'string') {
        return !!self;
      }
      return self != null;
    },
  }),
  createFilter({
    name: 'isEmpty',
    self: t.unknown.instance(),
    args: [] as const,
    label: 'Is empty',
    shortString: () => ': Is empty',
    impl: self => {
      if (Array.isArray(self)) {
        return self.length === 0;
      }
      if (typeof self === 'string') {
        return !self;
      }
      return self == null;
    },
  }),
  createFilter({
    name: 'countIs',
    self: t.unknown.instance(),
    args: [t.number.instance()] as const,
    label: 'Count is',
    shortString: v => (v?.value != null ? `: Count = ${v.value}` : undefined),
    impl: (self, n) => lengthOf(self) === n,
  }),
  createFilter({
    name: 'countGreaterThan',
    self: t.unknown.instance(),
    args: [t.number.instance()] as const,
    label: 'Count greater than',
    shortString: v => (v?.value != null ? `: Count > ${v.value}` : undefined),
    impl: (self, n) => lengthOf(self) > n,
  }),
  createFilter({
    name: 'countLessThan',
    self: t.unknown.instance(),
    args: [t.number.instance()] as const,
    label: 'Count less than',
    shortString: v => (v?.value != null ? `: Count < ${v.value}` : undefined),
    impl: (self, n) => lengthOf(self) < n,
  }),
];
